import debounce from 'lodash.debounce'

window.jQuery(document).ready(function () {
  $(".dropdown").hover(function () {
    $(this).addClass("open")
  }, function () {
    $(this).removeClass("open")
  })
  // $(".custom_rev_slider").show().revolution({
  //   delay: 5e3,
  //   sliderLayout: "fullwidth",
  //   sliderType: "standard",
  //   responsiveLevels: [1201, 1025, 768, 480],
  //   gridwidth: [1201, 1025, 769, 480],
  //   gridheight: [745, 744, 644, 544],
  //   dottedOverlay: "twoxtwo",
  //   navigation: {
  //     arrows: {enable: !0, style: "hesperiden", hide_onleave: !1},
  //     bullets: {
  //       enable: !0,
  //       style: "hesperiden",
  //       hide_onleave: !1,
  //       h_align: "center",
  //       v_align: "bottom",
  //       h_offset: 0,
  //       v_offset: 20,
  //       space: 15
  //     }
  //   },
  //   disableProgressBar: "on"
  // })
  // $("#rev_video_slider").show().revolution({
  //   dottedOverlay: "none",
  //   delay: 9e3,
  //   navigation: {onHoverStop: "off"},
  //   responsiveLevels: [1240, 1024, 778, 480],
  //   visibilityLevels: [1240, 1024, 778, 480],
  //   gridwidth: [1240, 1024, 778, 480],
  //   gridheight: [750, 550, 425, 250],
  //   shadow: 0,
  //   spinner: "off",
  //   stopLoop: "on",
  //   stopAfterLoops: 0,
  //   stopAtSlide: 1,
  //   shuffle: "off",
  //   autoHeight: "off",
  //   disableProgressBar: "on",
  //   hideThumbsOnMobile: "off",
  //   hideSliderAtLimit: 0,
  //   hideCaptionAtLimit: 0,
  //   hideAllCaptionAtLilmit: 0,
  //   debugMode: !1,
  //   fallbacks: {simplifyAll: "off", nextSlideOnWindowFocus: "off", disableFocusListener: !1}
  // })
  let e = $("#header-nav")
  $(window).scroll(debounce(() => {
    // $(window).scrollTop() >= 1 && $(".navbar-default").hasClass("navbar-main") ? e.addClass("darkHeader") : $(".navbar-default").hasClass("static-dark") ? e.addClass("darkHeader") : e.removeClass("darkHeader")
    // if ($(window).scrollTop() >= 1) {
    //   e.addClass("darkHeader").removeClass('navbar-static-top').addClass('navbar-fixed-top')
    // } else {
    //   e.removeClass("darkHeader").addClass('navbar-static-top').removeClass('navbar-fixed-top')
    // }
    // console.log('scrolling')
  }, 500))
  // $(".select-drop").selectbox()
  // $(".datepicker").datepicker({
  //   startDate: "dateToday",
  //   autoclose: !0
  // })
  // e(".counter").counterUp({delay: 10, time: 2000})
  // $("#price-range").slider({
  //   range: !0, min: 20, max: 300, values: [20, 300], slide: function (e, a) {
  //     $("#price-amount-1").val("$" + a.values[0]), $("#price-amount-2").val("$" + a.values[1])
  //   }
  // })
  // $("#price-amount-1").val("$" + $("#price-range").slider("values", 0)), $("#price-amount-2").val("$" + $("#price-range").slider("values", 1))
  let a = $(".singlePackage .panel-heading i.fa")
  $(".singlePackage .panel-heading").click(function () {
    a.removeClass("fa-minus").addClass("fa-plus"), $(this).find("i.fa").removeClass("fa-plus").addClass("fa-minus")
  })
  let i = $(".accordionWrappar .panel-heading i.fa")
  $(".accordionWrappar .panel-heading").click(function () {
    i.removeClass("fa-minus").addClass("fa-plus"), $(this).find("i.fa").removeClass("fa-plus").addClass("fa-minus")
  })
  let o = $(".solidBgTitle .panel-heading i.fa")
  $(".solidBgTitle .panel-heading").click(function () {
    o.removeClass("fa-minus").addClass("fa-plus"), $(this).find("i.fa").removeClass("fa-plus").addClass("fa-minus")
  })
  let s = $(".accordionSolidTitle .panel-heading i.fa")
  $(".accordionSolidTitle .panel-heading").click(function () {
    s.removeClass("fa-arrow-circle-up").addClass("fa-arrow-circle-down"), $(this).find("i.fa").removeClass("fa-arrow-circle-down").addClass("fa-arrow-circle-up")
  })
  let l = $(".accordionSolidBar .panel-heading i.fa")
  $(".accordionSolidBar .panel-heading").click(function () {
    l.removeClass("fa-chevron-circle-up").addClass("fa-chevron-circle-down"), $(this).find("i.fa").removeClass("fa-chevron-circle-down").addClass("fa-chevron-circle-up")
  })
  $(".accordionWrappar .panel-collapse, .accordionSolidTitle .panel-collapse, .accordionSolidBar .panel-collapse, .toggle-container .panel-collapse").on("show.bs.collapse", function () {
    $(this).siblings(".panel-heading").addClass("active"), $(this).addClass("active")
  }), $(".accordionWrappar .panel-collapse, .accordionSolidTitle .panel-collapse, .accordionSolidBar .panel-collapse, .toggle-container .panel-collapse").on("hide.bs.collapse", function () {
    $(this).siblings(".panel-heading").removeClass("active"), $(this).removeClass("active")
  })
  // $("#simple_timer").syotimer({
  //   year: 2018,
  //   month: 5,
  //   day: 9,
  //   hour: 20,
  //   minute: 30
  // })
  $(".incr-btn").on("click", function (e) {
    let a, i = $(this), o = i.parent().find(".quantity").val()
    i.parent().find(".incr-btn[data-action=decrease]").removeClass("inactive"), "increase" === i.data("action") ? a = parseFloat(o) + 1 : o > 1 ? a = parseFloat(o) - 1 : (a = 0, i.addClass("inactive")), i.parent().find(".quantity").val(a), e.preventDefault()
  })
  // $(".slick-carousel").slick({
  //   centerMode: !0,
  //   centerPadding: "100px",
  //   slidesToShow: 1,
  //   responsive: [{breakpoint: 1024, settings: {slidesToShow: 1, slidesToScroll: 1, infinite: !0}}, {
  //     breakpoint: 768,
  //     settings: {slidesToShow: 1, slidesToScroll: 1}
  //   }, {breakpoint: 480, settings: {slidesToShow: 1, slidesToScroll: 1, centerMode: !1}}]
  // })
  // $(".brandSlider").slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   centerMode: !0,
  //   centerPadding: "0px",
  //   responsive: [{breakpoint: 1024, settings: {slidesToShow: 3, slidesToScroll: 3, infinite: !0}}, {
  //     breakpoint: 768,
  //     settings: {slidesToShow: 2, slidesToScroll: 2}
  //   }, {breakpoint: 480, settings: {slidesToShow: 1, slidesToScroll: 1}}]
  // })


  $("body").click(function (event) {
    // only do this if navigation is visible, otherwise you see jump in navigation while collapse() is called
    if ($(".navbar-collapse").is(":visible") && $(".navbar-toggle").is(":visible")) {
      $('.navbar-collapse').collapse('hide');
    }
  });
})



// WEBPACK FOOTER //
// ./resources/assets/js/vendor/custom.js